import { computed, defineComponent, PropType, ref, watch } from "vue";
import { facetValue } from "../../interfaces/Filter";
import { useStore } from 'vuex';
import { includes } from "lodash";


export default defineComponent({
  name: "Bean",
  props: {
    singleFilter: {
      type: Object as PropType<facetValue>,
      required: true,
    }
  },
  setup(props) {

    const localFilter = ref<facetValue>({ ...props.singleFilter });
    const store = useStore();

    // Funzione per alternare il filtro usando Vuex
    const toggleFilter = (filter: facetValue) => {
      store.dispatch('toggleFilter', filter);
    };

    const formatClass = (label: string) => {
      return label.toLowerCase().replace(/[/\s]/g, '-');
    };

    const isSelected = computed(() => {
      return store.state.selectedFilters.some(
        (selected: facetValue) => selected.value === props.singleFilter.value
      );
    });

    const formattedLabel = computed(() => {
      const hasChildrenFilter = store.getters.selectedFilters.some(
        (filter: facetValue) => filter.label === "Children"
      ) || (store.getters.configurationParams.categoryName?.toLocaleLowerCase().includes('kids') || false);

      if (hasChildrenFilter) {
        if (props.singleFilter.label === "Man") return "Boy";
        if (props.singleFilter.label === "Woman") return "Girl";
      }

      return props.singleFilter.label === "Children" ? "Kids" : props.singleFilter.label;
    });

    watch(
      () => props.singleFilter,
      (filter: facetValue) => {
        localFilter.value = { ...filter }; // Clona l'oggetto di tipo facetValue
      }
    );


    return {
      singleFilter: localFilter, // Rendi le props disponibili nel template
      toggleFilter,
      formatClass,
      isSelected,
      formattedLabel
    };
  },
});
